export default __webpack_public_path__ + "static/media/Room_2.fce29840.png";